import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;

const OwnerService = {
    getAllToSelect: async () => axios.get(API_URL + "/owner/options/all").then(({data}) => data.data).catch((err) => { throw err }),
}

export default OwnerService;
